import Error from '../../error/components/Error';

import activationErrorSvg from '../../../assets/images/ActivationError.svg';

export const activationError = {
  firstLevel: () => <Error
    image={activationErrorSvg}
    meta={{
      description: 'client_errorActivatingAccount',
      keywords:    'default_meta_keywords',
      title:       'client_errorActivatingAccount_steelline',
    }}
    title={'client_errorActivatingAccount'}
  />,
};